import { apiPost, apiGet } from './api';
import type { EmailPreviewItem } from '@hypema/shared';

export interface OutreachDefaults {
  topicGoalText: string;
}

export async function getOutreachDefaults(): Promise<OutreachDefaults> {
  const tenant = await apiGet<any>('/tenants/current');
  return {
    topicGoalText: tenant.topicGoalText || '',
  };
}

export interface PreviewResult {
  previews: EmailPreviewItem[];
  count: number;
}

export async function generateEmailsPreview(params: {
  leadGroupId: string;
  topicGoalText?: string;
  feedbackHistory?: string[];
  sampleCount?: number;
  leadIds?: string[];
}): Promise<PreviewResult> {
  return apiPost<PreviewResult>('/ai/generate-emails-preview', params);
}

export interface BatchResult {
  generated: number;
  failed: number;
  total: number;
  failedLeads?: { leadId: string; error: string }[];
}

export async function generateEmailsBatch(params: {
  leadGroupId: string;
  topicGoalText?: string;
  feedbackHistory?: string[];
  leadIds?: string[];
  existingPreviews?: { leadId: string; subject: string; body: string }[];
}): Promise<BatchResult> {
  return apiPost<BatchResult>('/ai/generate-emails-batch', params);
}
